import React from 'react';
import { Checkbox, Form, CheckboxProps } from 'semantic-ui-react';

/**
 * Makes the Checkbox radio from "Semantic UI React" compatible with "React Final Form"
 */
const RadioButtonAdapter = ({
    input,
    meta,
    ...rest
}: any): React.ReactElement => (
    <Form.Field>
        <Checkbox
            {...input}
            {...rest}
            radio
            onChange={(
                _event: React.FormEvent<HTMLInputElement>,
                { value }: CheckboxProps
            ): void => input.onChange(value)}
        />
    </Form.Field>
);

export default RadioButtonAdapter;
